export const TASK_TYPE = {
  INIT: 10,
  CALCULATION_NECESSITY: 20,
  INITIAL_CALCULATION: 30,
  INITIAL_CALCULATION_CHECK: 40,
  INITIAL_BILLING: 50,
  WAITING_PAYMENT: 55,
  EXECUTION: 60,
  ADDITIONAL_CALCULATION: 70,
  ADDITIONAL_CALCULATION_CHECK: 80,
  ADDITIONAL_BILLING: 90,
  UNIVERSAL_TRANSFER_DOCUMENT: 100,
  CONTRACT_PREPARATION: 200,
  CONTRACT_PAYMENT_CONFIRMATION: 210,
};
